import { Attributes, Validation, ValueObject } from '@singularsystems/neo-core';

export default class AuthorisationValues extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }


    public isAuthorised: boolean = false;

    @Attributes.Date()
    public on: Date | null = null;

    @Attributes.Nullable()
    public userId: number | null = null;

    // Client only properties / methods

    /** Sets is authorised to true, does not set auth date or user. */
    public setAuthorised() {
        this.isAuthorised = true;
        this.isSelfDirty = false;
    }

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Authorisation Values";
    }
}